export const SET_SELECTED_CITY = 'SET_SELECTED_CITY';
export const GET_CITIES = 'GET_CITIES';
export const SET_CITIES = 'SET_CITIES';
export const GET_CITIES_ERROR = 'GET_CITIES_ERROR';
export const SET_PARAM_CITY = 'SET_PARAM_CITY';
